/**
 * @ngdoc controllers
 * @memberof mercury.modules.cashup
 * @name CashupOverviewCtrl
 * @description Overview page for viewing all cashup sets in the report period
 */
angular.module('mercury.modules.cashup.overview')
.controller('CashupOverviewCtrl', ["$filter", "$resource", "reporttime", "$scope", "$state", "$timeout", "title", "CashupSets", "userinfo", "dialog", function($filter, $resource, reporttime, $scope, $state, $timeout, title, CashupSets, userinfo, dialog) {
  title.set('Cashup Overview');

  reporttime.defaultType = 'week';

  $scope.pending = [];
  $scope.completed = [];

  $scope.companyPos = userinfo.companyPos();

  $scope.allReconciliations = CashupSets.get(reporttime.start(), reporttime.end())
  .then(function(result) {
    $scope.allReconciliations = result;

    var graphRows = [];
    angular.forEach($scope.allReconciliations, function(recon) {
      if (recon.committed) {
        $scope.completed.push(recon);
      } else {
        $scope.pending.push(recon);
      }

      var value = recon.cashVariance + recon.otherVariance;
      var color = recon.committed === false ? '#fa6b5b' : '#00b1e2';
      graphRows.push({c: [
        {v: moment(recon.datestampEnd).mStartOf('day').format('ddd, Do, MMM')},
        {v: value, f: $filter('currency')(value)},
        {v: 'color: ' + color}
      ], recon: recon});
    });

    $scope.graphData = {
      cols: [
        {label: 'Day', type: 'string'},
        {label: 'Variance', type: 'number'},
        {label: '', type: 'string', role: 'style'}
      ],
      rows: graphRows
    };
  });

  $scope.graphData = null;
  $scope.graphOptions = {
    colors: [],
    onSelect: function(selected) {
      var recon = $scope.graphData.rows[selected[0].row].recon;
      $timeout(function() {
        if (recon.committed === false) {
          $state.go('Cashups.Edit', {reconId: recon.id});
        } else {
          $state.go('Cashups.View', {reconId: recon.id});
        }
      });
    }
  };

  $scope.formatReconDate = function(input) {
    return moment(input).mStartOf('day').format('ddd, Do, MMM');
  };

  $scope.addCashupSet = function() {
    $scope.creatingCashup = CashupSets.add();
    $scope.creatingCashup.then(function(result) {
      $scope.allReconciliations.push(result.data);
      if (result.committed) {
        $scope.completed.push(result.data);
      } else {
        $scope.pending.push(result.data);
      }
      if (result.data.firstCashupSet) {
        dialog.alert('Hey, this looks like the first cashup you have ever completed for this site. To keep it simple your first cashup will only include sales ' +
        'for the last 24 hours. We recommend completing this at the close of trading for the day, so that the initial cashup captures the correct trading period.');
      }
    });
  };
}]);
